import { render, staticRenderFns } from "./EmployeesTable.vue?vue&type=template&id=06f8ca16&scoped=true&"
import script from "./EmployeesTable.vue?vue&type=script&lang=ts&"
export * from "./EmployeesTable.vue?vue&type=script&lang=ts&"
import style0 from "./EmployeesTable.vue?vue&type=style&index=0&id=06f8ca16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f8ca16",
  null
  
)

export default component.exports